import React from 'react';

import { useExportSet, useGetRedemptionReport } from 'scenes/PromoCodes/data';
import { useDeactivatePromoCode } from 'scenes/PromoCodes/data/mutations';

import { Actions } from './Actions';

const PromoCodeActions = ({
  data,
  actions,
  onEdit,
  onEditSet,
  onDuplicate,
}) => {
  const exportSet = useExportSet();
  const getRedemptionReport = useGetRedemptionReport();

  const [deactivatePromoCode] = useDeactivatePromoCode();

  const handleDeactivateAction = () => deactivatePromoCode(data);

  const handleExport = async () => {
    await exportSet(data);
  };

  const handleGetRedemptionReport = async () => {
    await getRedemptionReport(data);
  };

  const handleEdit = () => onEdit?.(data);
  const handleEditSet = () => onEditSet?.(data);
  const handleDuplicate = () => onDuplicate?.(data);

  return (
    <Actions
      actions={actions}
      isSet={data?.isSet}
      data={data}
      onDeactivate={handleDeactivateAction}
      onExport={handleExport}
      onDuplicate={handleDuplicate}
      onEdit={handleEdit}
      onEditSet={handleEditSet}
      onGetRedemptionReport={handleGetRedemptionReport}
    />
  );
};

export default PromoCodeActions;
